import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import { fallBackLocale } from './constants';
import { getLocale } from './util';
import { REACT_APP_CONTEXT_PATH } from './config';

export const callMissingKeyCallback = (key) => {
  return '';
};

i18n
  .use(Backend)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    backend: {
      loadPath: `${REACT_APP_CONTEXT_PATH}/assets/locales/{{lng}}.json`, // Resource files in public/locales
    },
    // Only have locale files (en-US) and not lng only code files (en)
    // 'currentOnly' will load exact lng, ie 'en-US' and not both ['en', 'en-US']
    load: 'currentOnly',
    partialBundledLanguages: true,
    ns: [],
    defaultNS: ['translations'],
    resources: {}, // Resources will be load by backend
    preload: [fallBackLocale], // preload doesn't seem to work...?
    fallbackLng: fallBackLocale,
    lng: getLocale(),
    interpolation: {
      escapeValue: false, // react already safe from xss
    },
    react: {
      useSuspense: false, // Set to true if using React 18's Suspense feature
    },
    // Default behavior for missing keys
    saveMissing: true, // Must be set to true
    parseMissingKeyHandler: callMissingKeyCallback,
  });

export default i18n;
